export const containerTranslations = {
  en: {
    title: 'Reusable containers and deposits',
    customer: 'Customer',
    type: 'Container type',
    outstanding: 'Outstanding',
    damaged: 'Received damaged',
    deposit: 'Deposit balance',
    issue: 'Record confirmed issue',
    receive: 'Receive containers',
    opening: 'Record opening balance',
    correction: 'Reverse entry',
    credit: 'Create deposit credit',
    charge: 'Link billed deposit',
    settings: 'Container settings',
    reusable: 'Reusable',
    ownership: 'Ownership',
    company: 'Company',
    pool: 'Pool',
    customerOwned: 'Customer',
    depositProduct: 'Deposit product',
    depositRate: 'Deposit per container',
    currency: 'Currency',
    countUnit: 'Counting unit',
    conditions: 'Accepted return conditions',
    good: 'Good',
    print: 'Print on documents',
    quantity: 'Quantity',
    reason: 'Reason',
    source: 'Original source',
    shipment: 'Shipment',
    entry: 'Ledger entry',
    depositItem: 'Invoice deposit position',
    confirmedOnly:
      'Only fresh confirmed shipment quantities are issued. Calculated packaging totals are estimates.',
    returnIdentity: 'Physical return reference',
    returnIdentityHint:
      'Use the same receipt or driver stop reference when recording the same physical return again.',
    save: 'Save',
    retry: 'Retry',
    loading: 'Loading…',
    empty: 'No entries for this customer.',
    error: 'The operation failed. Your inputs have been retained.',
    saved: 'Saved',
    exportCsv: 'Export CSV',
    exportPdf: 'Export PDF',
    history: 'History',
    select: 'Select…',
    errors: {
      depositProduct: 'Choose a deposit product for a positive deposit rate.',
      damageQuantity: 'Damaged quantity exceeds total received.',
      duplicateType: 'Choose each container type once.',
      type: 'Select an active central packaging type.',
      confirmedShipment: 'Confirm the actual shipment quantities before posting containers.',
      depositProof:
        'Select the original posted invoice deposit position; its quantities, customer, rate and currency must match.',
      oneWay: 'One-way packaging has no reusable-container account.',
      exceedsBalance: 'The return exceeds the outstanding container balance.',
      unresolvedOpening: 'Clarify the opening balance before allocating this return.',
      correctFinancial: 'Financially linked entries require a correcting financial document.',
      usedIssue: 'This issue already has related returns.',
      alreadyCredited: 'This return deposit is already credited.',
      alreadyCharged: 'This issue already has a billed deposit link.',
      chargeBeforeReturn: 'Link the billed deposit before recording the container return.',
      condition: 'This return condition is not permitted.',
      currencyOutstanding: 'Clear all outstanding containers before changing the deposit currency.',
      outstandingPolicy:
        'Clear all outstanding quantities before changing this reusable type to one-way.',
    },
    kinds: {
      ISSUE: 'Issue',
      RETURN: 'Return',
      OPENING: 'Opening',
      CORRECTION: 'Correction',
      DEPOSIT_CHARGE: 'Billed deposit',
      DEPOSIT_CREDIT: 'Deposit credit',
      LOSS: 'Loss',
      DAMAGE: 'Breakage',
    },
    events: {
      confirmedShipment: 'Record confirmed issue',
    },
    loss: 'Record loss or breakage',
  },
  de: {
    title: 'Mehrweggebinde und Pfand',
    customer: 'Kunde',
    type: 'Gebindeart',
    outstanding: 'Offen',
    damaged: 'Beschädigt erhalten',
    deposit: 'Pfandsaldo',
    issue: 'Bestätigte Ausgabe erfassen',
    receive: 'Gebinde annehmen',
    opening: 'Anfangssaldo erfassen',
    correction: 'Eintrag gegenbuchen',
    credit: 'Pfandgutschrift erstellen',
    charge: 'Berechnetes Pfand zuordnen',
    settings: 'Gebindeeinstellungen',
    reusable: 'Mehrweg',
    ownership: 'Eigentum',
    company: 'Unternehmen',
    pool: 'Pool',
    customerOwned: 'Kunde',
    depositProduct: 'Pfandartikel',
    depositRate: 'Pfand je Gebinde',
    currency: 'Währung',
    countUnit: 'Zähleinheit',
    conditions: 'Zulässige Rückgabezustände',
    good: 'Einwandfrei',
    print: 'Auf Belegen drucken',
    quantity: 'Menge',
    reason: 'Grund',
    source: 'Ursprünglicher Bezug',
    shipment: 'Lieferung',
    entry: 'Kontoeintrag',
    depositItem: 'Pfandposition der Rechnung',
    confirmedOnly:
      'Ausgaben verwenden nur aktuelle bestätigte Liefermengen. Berechnete Gebindezahlen sind Schätzungen.',
    returnIdentity: 'Bezug der physischen Rückgabe',
    returnIdentityHint:
      'Verwende bei derselben physischen Rückgabe denselben Wareneingangs- oder Fahrer-Stopp-Bezug.',
    save: 'Speichern',
    retry: 'Erneut versuchen',
    loading: 'Wird geladen…',
    empty: 'Für diesen Kunden gibt es noch keine Einträge.',
    error: 'Der Vorgang ist fehlgeschlagen. Deine Eingaben bleiben erhalten.',
    saved: 'Gespeichert',
    exportCsv: 'CSV exportieren',
    exportPdf: 'PDF exportieren',
    history: 'Verlauf',
    select: 'Auswählen…',
    errors: {
      depositProduct: 'Wähle bei positivem Pfand einen Pfandartikel.',
      damageQuantity: 'Die beschädigte Menge überschreitet die erhaltene Gesamtmenge.',
      duplicateType: 'Wähle jede Gebindeart nur einmal.',
      type: 'Wähle eine aktive zentrale Gebindeart.',
      confirmedShipment: 'Bestätige die tatsächlichen Liefermengen vor der Gebindebuchung.',
      depositProof:
        'Wähle die ursprüngliche festgeschriebene Pfandposition; Mengen, Kunde, Satz und Währung müssen passen.',
      oneWay: 'Einwegverpackungen haben kein Mehrwegkonto.',
      exceedsBalance: 'Die Rückgabe überschreitet den offenen Gebindesaldo.',
      unresolvedOpening: 'Kläre den Anfangssaldo vor der Zuordnung dieser Rückgabe.',
      correctFinancial:
        'Finanziell verknüpfte Einträge benötigen einen finanziellen Korrekturbeleg.',
      usedIssue: 'Zu dieser Ausgabe sind bereits Rückgaben erfasst.',
      alreadyCredited: 'Dieses Rückgabepfand wurde bereits gutgeschrieben.',
      alreadyCharged: 'Diese Ausgabe hat bereits einen berechneten Pfandbezug.',
      chargeBeforeReturn: 'Ordne das berechnete Pfand vor der Gebinderückgabe zu.',
      condition: 'Dieser Rückgabezustand ist nicht zugelassen.',
      currencyOutstanding:
        'Vor einem Wechsel der Pfandwährung müssen alle offenen Gebindemengen ausgeglichen sein.',
      outstandingPolicy:
        'Gleichen Sie offene Mengen aus, bevor Sie die Mehrwegart als Einweg führen.',
    },
    kinds: {
      ISSUE: 'Ausgabe',
      RETURN: 'Rückgabe',
      OPENING: 'Anfangssaldo',
      CORRECTION: 'Gegenbuchung',
      DEPOSIT_CHARGE: 'Berechnetes Pfand',
      DEPOSIT_CREDIT: 'Pfandgutschrift',
      LOSS: 'Verlust',
      DAMAGE: 'Bruch',
    },
    events: {
      confirmedShipment: 'Bestätigte Ausgabe erfassen',
    },
    loss: 'Verlust oder Bruch erfassen',
  },
  fr: {
    title: 'Emballages réutilisables et consignes',
    customer: 'Client',
    type: 'Type d’emballage',
    outstanding: 'En circulation',
    damaged: 'Reçus endommagés',
    deposit: 'Solde de consigne',
    issue: 'Enregistrer une sortie confirmée',
    receive: 'Recevoir les emballages',
    opening: 'Enregistrer le solde initial',
    correction: 'Contrepasser une écriture',
    credit: 'Créer un avoir de consigne',
    charge: 'Lier une consigne facturée',
    settings: 'Paramètres des emballages',
    reusable: 'Réutilisable',
    ownership: 'Propriété',
    company: 'Entreprise',
    pool: 'Pool',
    customerOwned: 'Client',
    depositProduct: 'Article de consigne',
    depositRate: 'Consigne par emballage',
    currency: 'Devise',
    countUnit: 'Unité de comptage',
    conditions: 'États de retour acceptés',
    good: 'Bon état',
    print: 'Imprimer sur les documents',
    quantity: 'Quantité',
    reason: 'Motif',
    source: 'Référence d’origine',
    shipment: 'Livraison',
    entry: 'Écriture du compte',
    depositItem: 'Ligne de consigne facturée',
    confirmedOnly:
      'Seules les quantités de livraison confirmées et actuelles sont enregistrées. Les calculs sont des estimations.',
    returnIdentity: 'Référence du retour physique',
    returnIdentityHint:
      'Réutilisez la même référence de réception ou d’arrêt pour le même retour physique.',
    save: 'Enregistrer',
    retry: 'Réessayer',
    loading: 'Chargement…',
    empty: 'Aucune écriture pour ce client.',
    error: 'L’opération a échoué. Vos saisies sont conservées.',
    saved: 'Enregistré',
    exportCsv: 'Exporter en CSV',
    exportPdf: 'Exporter en PDF',
    history: 'Historique',
    select: 'Sélectionner…',
    errors: {
      depositProduct: 'Choisissez un article pour une consigne positive.',
      damageQuantity: 'La quantité endommagée dépasse la réception totale.',
      duplicateType: 'Sélectionnez chaque type une seule fois.',
      type: 'Choisissez un type central actif.',
      confirmedShipment: 'Confirmez les quantités livrées réelles avant l’écriture.',
      depositProof:
        'Choisissez la ligne de consigne comptabilisée d’origine ; quantités, client, tarif et devise doivent correspondre.',
      oneWay: 'Les emballages jetables n’ont pas de compte réutilisable.',
      exceedsBalance: 'Le retour dépasse le solde en circulation.',
      unresolvedOpening: 'Clarifiez le solde initial avant d’affecter ce retour.',
      correctFinancial: 'Une écriture liée financièrement exige un document de correction.',
      usedIssue: 'Cette sortie possède déjà des retours.',
      alreadyCredited: 'Cette consigne de retour est déjà créditée.',
      alreadyCharged: 'Cette sortie est déjà liée à une consigne facturée.',
      chargeBeforeReturn: 'Liez la consigne facturée avant le retour des emballages.',
      condition: 'Cet état de retour n’est pas autorisé.',
      currencyOutstanding:
        'Soldez tous les emballages en circulation avant de modifier la devise de consigne.',
      outstandingPolicy:
        'Soldez les quantités en circulation avant de rendre ce type non réutilisable.',
    },
    kinds: {
      ISSUE: 'Sortie',
      RETURN: 'Retour',
      OPENING: 'Solde initial',
      CORRECTION: 'Contrepassation',
      DEPOSIT_CHARGE: 'Consigne facturée',
      DEPOSIT_CREDIT: 'Avoir de consigne',
      LOSS: 'Perte',
      DAMAGE: 'Casse',
    },
    events: {
      confirmedShipment: 'Enregistrer une sortie confirmée',
    },
    loss: 'Enregistrer une perte ou une casse',
  },
  es: {
    title: 'Envases reutilizables y depósitos',
    customer: 'Cliente',
    type: 'Tipo de envase',
    outstanding: 'Pendiente',
    damaged: 'Recibidos dañados',
    deposit: 'Saldo del depósito',
    issue: 'Registrar salida confirmada',
    receive: 'Recibir envases',
    opening: 'Registrar saldo inicial',
    correction: 'Revertir asiento',
    credit: 'Crear abono de depósito',
    charge: 'Vincular depósito facturado',
    settings: 'Configuración de envases',
    reusable: 'Reutilizable',
    ownership: 'Propiedad',
    company: 'Empresa',
    pool: 'Pool',
    customerOwned: 'Cliente',
    depositProduct: 'Artículo de depósito',
    depositRate: 'Depósito por envase',
    currency: 'Divisa',
    countUnit: 'Unidad de recuento',
    conditions: 'Estados de devolución aceptados',
    good: 'Buen estado',
    print: 'Imprimir en documentos',
    quantity: 'Cantidad',
    reason: 'Motivo',
    source: 'Referencia original',
    shipment: 'Envío',
    entry: 'Asiento',
    depositItem: 'Línea de depósito facturada',
    confirmedOnly:
      'Solo se registran cantidades de envío confirmadas y vigentes. Los cálculos son estimaciones.',
    returnIdentity: 'Referencia de devolución física',
    returnIdentityHint:
      'Utiliza la misma referencia de recepción o parada para la misma devolución física.',
    save: 'Guardar',
    retry: 'Reintentar',
    loading: 'Cargando…',
    empty: 'No hay asientos para este cliente.',
    error: 'La operación falló. Se conservan tus datos.',
    saved: 'Guardado',
    exportCsv: 'Exportar CSV',
    exportPdf: 'Exportar PDF',
    history: 'Historial',
    select: 'Seleccionar…',
    errors: {
      depositProduct: 'Selecciona un artículo para un depósito positivo.',
      damageQuantity: 'La cantidad dañada supera la recepción total.',
      duplicateType: 'Selecciona cada tipo una sola vez.',
      type: 'Selecciona un tipo central activo.',
      confirmedShipment: 'Confirma las cantidades reales enviadas antes de registrar.',
      depositProof:
        'Selecciona la línea de depósito contabilizada original; cantidades, cliente, tarifa y divisa deben coincidir.',
      oneWay: 'Los envases de un solo uso no tienen cuenta reutilizable.',
      exceedsBalance: 'La devolución supera el saldo pendiente.',
      unresolvedOpening: 'Aclara el saldo inicial antes de asignar la devolución.',
      correctFinancial: 'Un asiento con vínculo financiero requiere un documento de corrección.',
      usedIssue: 'Esta salida ya tiene devoluciones asociadas.',
      alreadyCredited: 'Este depósito ya está abonado.',
      alreadyCharged: 'Esta salida ya está vinculada a un depósito facturado.',
      chargeBeforeReturn: 'Vincula el depósito facturado antes de recibir los envases.',
      condition: 'Este estado de devolución no está permitido.',
      currencyOutstanding:
        'Liquide todos los envases pendientes antes de cambiar la moneda del depósito.',
      outstandingPolicy:
        'Liquide las cantidades pendientes antes de convertir este tipo en desechable.',
    },
    kinds: {
      ISSUE: 'Salida',
      RETURN: 'Devolución',
      OPENING: 'Saldo inicial',
      CORRECTION: 'Reversión',
      DEPOSIT_CHARGE: 'Depósito facturado',
      DEPOSIT_CREDIT: 'Abono de depósito',
      LOSS: 'Pérdida',
      DAMAGE: 'Rotura',
    },
    events: {
      confirmedShipment: 'Registrar salida confirmada',
    },
    loss: 'Registrar pérdida o rotura',
  },
  tr: {
    title: 'Yeniden kullanılabilir ambalaj ve depozitolar',
    customer: 'Müşteri',
    type: 'Ambalaj türü',
    outstanding: 'Açık',
    damaged: 'Hasarlı alınan',
    deposit: 'Depozito bakiyesi',
    issue: 'Onaylı çıkışı kaydet',
    receive: 'Ambalajları al',
    opening: 'Açılış bakiyesi kaydet',
    correction: 'Kaydı tersine çevir',
    credit: 'Depozito alacağı oluştur',
    charge: 'Faturalanan depozitoyu bağla',
    settings: 'Ambalaj ayarları',
    reusable: 'Yeniden kullanılabilir',
    ownership: 'Mülkiyet',
    company: 'Şirket',
    pool: 'Havuz',
    customerOwned: 'Müşteri',
    depositProduct: 'Depozito ürünü',
    depositRate: 'Ambalaj başına depozito',
    currency: 'Para birimi',
    countUnit: 'Sayım birimi',
    conditions: 'Kabul edilen iade koşulları',
    good: 'Sağlam',
    print: 'Belgelerde yazdır',
    quantity: 'Miktar',
    reason: 'Neden',
    source: 'Orijinal kaynak',
    shipment: 'Sevkiyat',
    entry: 'Hesap kaydı',
    depositItem: 'Fatura depozito satırı',
    confirmedOnly:
      'Yalnızca güncel ve onaylı sevkiyat miktarları kaydedilir. Hesaplanan miktarlar tahmindir.',
    returnIdentity: 'Fiziksel iade referansı',
    returnIdentityHint:
      'Aynı fiziksel iade için aynı kabul veya sürücü durağı referansını kullanın.',
    save: 'Kaydet',
    retry: 'Yeniden dene',
    loading: 'Yükleniyor…',
    empty: 'Bu müşteri için kayıt yok.',
    error: 'İşlem başarısız oldu. Girdileriniz korundu.',
    saved: 'Kaydedildi',
    exportCsv: 'CSV dışa aktar',
    exportPdf: 'PDF dışa aktar',
    history: 'Geçmiş',
    select: 'Seçin…',
    errors: {
      depositProduct: 'Pozitif depozito için depozito ürünü seçin.',
      damageQuantity: 'Hasarlı miktar alınan toplamı aşıyor.',
      duplicateType: 'Her türü bir kez seçin.',
      type: 'Etkin bir merkezi ambalaj türü seçin.',
      confirmedShipment: 'Kaydetmeden önce gerçek sevkiyat miktarlarını onaylayın.',
      depositProof:
        'Orijinal kesinleşmiş depozito satırını seçin; miktar, müşteri, oran ve para birimi eşleşmelidir.',
      oneWay: 'Tek kullanımlık ambalajın yeniden kullanım hesabı yoktur.',
      exceedsBalance: 'İade açık ambalaj bakiyesini aşıyor.',
      unresolvedOpening: 'Bu iadeyi dağıtmadan önce açılış bakiyesini açıklayın.',
      correctFinancial: 'Mali bağlantılı kayıt için düzeltme belgesi gereklidir.',
      usedIssue: 'Bu çıkışın ilişkili iadeleri var.',
      alreadyCredited: 'Bu iadenin depozitosu zaten alacak kaydedilmiş.',
      alreadyCharged: 'Bu çıkışın faturalanmış depozito bağlantısı var.',
      chargeBeforeReturn: 'Ambalaj iadesinden önce faturalanan depozitoyu bağlayın.',
      condition: 'Bu iade koşuluna izin verilmiyor.',
      currencyOutstanding:
        'Depozito para birimini değiştirmeden önce tüm açık ambalaj miktarlarını kapatın.',
      outstandingPolicy: 'Bu türü tek kullanımlık yapmadan önce tüm açık miktarları kapatın.',
    },
    kinds: {
      ISSUE: 'Çıkış',
      RETURN: 'İade',
      OPENING: 'Açılış',
      CORRECTION: 'Düzeltme',
      DEPOSIT_CHARGE: 'Faturalanan depozito',
      DEPOSIT_CREDIT: 'Depozito alacağı',
      LOSS: 'Kayıp',
      DAMAGE: 'Kırılma',
    },
    events: {
      confirmedShipment: 'Onaylı çıkışı kaydet',
    },
    loss: 'Kayıp veya kırılma kaydet',
  },
} as const;
